module.exports = __webpack_public_path__ + "static/media/cloud-img-1.3be14850.png";